import axios from 'axios';

// API endpoints
export const api = {
  // Categories
  getCategories: () => axios.get('/api/categories'),
  getCategory: (slug) => axios.get(`/api/categories/${slug}`),
  createCategory: (data) => axios.post('/api/categories', data),
  updateCategory: (id, data) => axios.put(`/api/categories/${id}`, data),
  deleteCategory: (id) => axios.delete(`/api/categories/${id}`),
  reorderCategories: (categories) => axios.post('/api/categories/reorder', { categories }),

  // Sections
  getSections: (categoryId) => axios.get('/api/sections', { params: { category_id: categoryId } }),
  getSection: (slug) => axios.get(`/api/sections/${slug}`),
  createSection: (data) => axios.post('/api/sections', data),
  updateSection: (id, data) => axios.put(`/api/sections/${id}`, data),
  deleteSection: (id) => axios.delete(`/api/sections/${id}`),
  searchSections: (query) => axios.get(`/api/sections/search/${query}`),
  reorderSections: (sections) => axios.post('/api/sections/reorder', { sections }),

  // Media
  uploadMedia: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  getMedia: (type) => axios.get('/api/media', { params: { type } }),
  deleteMedia: (id) => axios.delete(`/api/media/${id}`),

  // Guestbook
  getGuestbookEntries: () => axios.get('/api/guestbook'),
  getAdminGuestbookEntries: () => axios.get('/api/guestbook/admin'),
  createGuestbookEntry: (formData) => {
    // formData is already a FormData object from the component
    return axios.post('/api/guestbook', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  approveGuestbookEntry: (id, approve = true) => 
    axios.put(`/api/guestbook/${id}/approve`, { is_approved: approve }),
  deleteGuestbookEntry: (id) => axios.delete(`/api/guestbook/${id}`),

  // Settings
  getSettings: () => axios.get('/api/settings'),
  getPublicSettings: () => axios.get('/api/settings/public'),
  updateSettings: (settings) => axios.put('/api/settings', settings),

  // Quick Info
  getQuickInfoItems: () => axios.get('/api/quick-info'),
  getAdminQuickInfoItems: () => axios.get('/api/quick-info/admin'),
  getQuickInfoItem: (id) => axios.get(`/api/quick-info/${id}`),
  createQuickInfoItem: (data) => axios.post('/api/quick-info', data),
  updateQuickInfoItem: (id, data) => axios.put(`/api/quick-info/${id}`, data),
  deleteQuickInfoItem: (id) => axios.delete(`/api/quick-info/${id}`),
  reorderQuickInfoItems: (items) => axios.post('/api/quick-info/reorder', { items }),

  // Contact
  logContact: (data) => axios.post('/api/contact/log', data),
  getContactLogs: () => axios.get('/api/contact/logs'),

  // QR Codes
  generateQRCode: (type, slug, baseUrl) => 
    axios.get(`/api/qr/generate/${type}/${slug}`, { params: { baseUrl } }),
  getAllQRCodes: (baseUrl) => axios.get('/api/qr/all', { params: { baseUrl } }),

  // Auth
  login: (credentials) => axios.post('/api/auth/login', credentials),
  getCurrentUser: () => axios.get('/api/auth/me'),
  setupAdmin: (data) => axios.post('/api/auth/setup', data),
  changePassword: (data) => axios.post('/api/auth/change-password', data),
  setSitePassword: (data) => axios.post('/api/site-auth/set-password', data),

  // Admin - Export/Import
  exportData: () => axios.get('/api/admin/export'),
  importData: (data) => axios.post('/api/admin/import', data, {
    maxContentLength: Infinity,
    maxBodyLength: Infinity
  }),
};